export default {
  title: 'Legs universel',
  subtitle: 'Simuler une mise en place d\'un legs universel',
  options: {
    choice: {
      yes: 'Avec leg universel',
      no: 'Sans legs universel'
    }
  },
  label: {
    choice: 'Choisir une option',
    legators: 'Légataires',
    date: 'Date d\'effet',
  },
  section: {
    info: 'Informations principales',
    legators: 'Légataires'
  }
}
